import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield } from 'lucide-react';
import { toast } from 'sonner';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error('Password must be at least 8 characters');
    if (pw !== pw2) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await api.post('/auth/password/reset', { token, new_password: pw });
      toast.success('Password reset. Please sign in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-lg p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 bg-[#0055FF] flex items-center justify-center rounded"><Shield className="w-5 h-5 text-white" /></div>
          <span className="font-heading text-lg font-semibold">LeadXchange</span>
        </div>
        <h1 className="font-heading text-2xl font-semibold text-gray-900 mb-6">Set a new password</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>New password</Label>
            <Input type="password" required minLength={8} value={pw} onChange={e => setPw(e.target.value)} data-testid="reset-pw-input" />
          </div>
          <div>
            <Label>Confirm password</Label>
            <Input type="password" required minLength={8} value={pw2} onChange={e => setPw2(e.target.value)} data-testid="reset-pw2-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#0055FF] hover:bg-[#0044CC] text-white" data-testid="reset-submit-btn">
            {loading ? 'Resetting…' : 'Reset password'}
          </Button>
          <div className="text-xs text-gray-500 text-center pt-2">
            <Link to="/login" className="underline">Back to sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
